import { Text } from '@billy/design-system'
import { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { VatDeclarationsReportSection as VatDeclarationsReportSectionType } from '@features/vatDeclarations/types/vatDeclarationsReportSection'

import * as Styled from './styles'
import { HeadCell, HeadRow } from './styles'
import { TableBody } from './TableBody'

interface TableProps {
  reportSection: VatDeclarationsReportSectionType
  showTitle?: boolean
}

export const Table = ({ reportSection, showTitle = true }: TableProps): ReactElement => {
  const { t } = useTranslation()

  const hasTurnoverAmount = useMemo(
    () => reportSection.fields.some((field) => field.turnoverAmount !== undefined),
    [reportSection.fields],
  )
  const hasVatAmount = useMemo(
    () => reportSection.fields.some((field) => field.vatAmount !== undefined),
    [reportSection.fields],
  )
  const title = showTitle && reportSection.name ? reportSection.name.split(' - ')[1] : ''

  return (
    <Styled.Table>
      <thead>
        <HeadRow>
          <HeadCell scope="col">
            <Text variant="bodyLG" weight="bold">
              {title}
            </Text>
          </HeadCell>
          <HeadCell scope="col">
            {hasTurnoverAmount && <Text nowrap>{t('vat_declaration.details_table.header.turnover')}</Text>}
          </HeadCell>
          <HeadCell scope="col">
            {hasVatAmount && <Text nowrap>{t('vat_declaration.details_table.header.vat')}</Text>}
          </HeadCell>
        </HeadRow>
      </thead>
      <TableBody tableRowsData={reportSection.fields} />
    </Styled.Table>
  )
}
